import { Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "../../../src/assets/orders/Save.svg";
import { useDispatch, useSelector } from "react-redux";
import { addIcon, heartIcon, starIcon } from "./svg";
import { setConfig } from "../../reduxtoolkit/userconfigslice";
import { OrderIcons } from "../OrderCards";
import { getPracticeId } from "../../config/practice";
import { resolveOrderDate } from "../../utils/orderdate";
const ScheduleButtons = ({
  data,
  userdata,
  selectedCard,
  loading,
  dt,
  selectedSuggestionList,
  fetchsuggestions,
}) => {
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [selectedAddTabs, setSelectedAddTabs] = useState(false);

  const practiseid = getPracticeId();

  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );

  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const dispatch=useDispatch()
 const userConfig = useSelector((state) => state.userconfig);
let fav=userConfig?.config?.fav_schedules||[]
  useEffect(() => {
    if (
      !Array.isArray(selectedSuggestionList) ||
      selectedSuggestionList.length === 0
    ) {
      setSelectedTabs([]); // Clear the selected tabs if the suggestion list is invalid or empty
      return;
    }

    const selectedItems = data
      .map((item) =>
        selectedSuggestionList.some(
          (suggestion) => suggestion.ordername === item.content
        )
          ? item.content
          : null
      )
      .filter((content) => content !== null); // Filter out null values

    setSelectedTabs(selectedItems);
  }, [data, selectedSuggestionList]);

  console.log("Userdata", selectedSuggestionList);

  const handleTabClick = async (itemContent) => {
    const isSelected = selectedTabs.includes(itemContent);
    const orderType = ["STREP TEST", "FLU TEST", "COVID TEST"].includes(
      itemContent
    )
      ? "Diagnostic test"
      : "Schedule-RTO";
    try {
      if (isSelected) {
        // Call delete API
        const orderToDelete = selectedSuggestionList.find(
          (x) => x.ordername === itemContent
        );

        if (orderToDelete) {
          const deleteResponse = await api.delete(
            `/v1/${practiseid}/orders/delete/order/${orderToDelete.ordre_id}`,
            {
              data: {
                // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
                // the date this tab's list was loaded for (never today's fallback: the server
                // picks orders_master or its history table from it, and their ids collide)
                orderdate: resolveOrderDate(dt),
                // scopes the delete to this patient where the server supports it
                ...(userdata?.patientid ? { patientid: Number(userdata.patientid) } : {}),
              },
            }
          );
          console.log("Delete API Response:", deleteResponse.data);
        } else {
          console.error("Order ID not found for deletion");
        }
      } else {
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${userdata.patientid}/orders/create`,
          {
            department_id: 1,
            patient_name: `${userdata.firstname || ""} ${
              userdata.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: userdata.lov,
            diagnosis: "",
            ordertype: orderType, // tabs
            ordername: itemContent, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: userdata.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:
              dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                ? dt.split(" ")[0]
                : new Date().toISOString().split("T")[0],
            encounterid: 0,
          }
        );
      }

      // Update state after the API call
      setSelectedTabs((prevSelected) => {
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((content) => content !== itemContent);
        } else {
          // Select if not already selected
          return [...prevSelected, itemContent];
        }
      });
      fetchsuggestions();
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  let isLoadingInHouseLabs = false; // This will track whether the function is already running
 const inHouseLabsContent = [
      "CBC",
      "A1C",
      "CMP",
      "LIPIDS",
      "MAGNESIUM",
      "URIC ACID",
      "THYROID PANEL",
      "VIT D",
      "VIT B12",
      "TESTO",
    ];
  const handleInHouseLabsClick = async () => {
    if (isLoadingInHouseLabs) return; // Prevent double-clicking if already loading
    isLoadingInHouseLabs = true; // Set loading to true to prevent further invocations

   
    try {
      // Filter out the items that are already in selectedTabs
      const itemsToAdd = inHouseLabsContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !selectedSuggestionList.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs in parallel
        await Promise.all(itemsToAdd.map((content) => handleTabClick(content)));

        // Update selectedTabs with the newly added items
        selectedTabs.push(...itemsToAdd);
      }
    } catch (error) {
      console.error("Error in handleInHouseLabsClick:", error);
    } finally {
      isLoadingInHouseLabs = false; // Reset the loading state after the operation is complete
    }
  };

  let isLoading = false; // This will track whether the function is already running
const stripfluContent = ["STREP TEST", "FLU TEST", "COVID TEST"];
  const handleStrepFluCovidClick = async () => {
    if (isLoading) return; // Prevent double-clicking if already loading
    isLoading = true; // Set loading to true to prevent further invocations

    

    try {
      // First, filter out the items that are already in selectedTabs or selectedSuggestionList
      const itemsToAdd = stripfluContent.filter(
        (content) =>
          !selectedTabs.includes(content) &&
          !selectedSuggestionList.some((item) => item.ordername === content)
      );

      if (itemsToAdd.length > 0) {
        // Call handleTabClick for all items that are not in selectedTabs or selectedSuggestionList in parallel
        await Promise.all(itemsToAdd.map((content) => handleTabClick(content)));
      }
    } catch (error) {
      console.error("Error in handleStrepFluCovidClick:", error);
    } finally {
      isLoading = false; // Reset the loading state after the operation is complete
    }
  };

  console.log("Selected Suggestion List:", selectedSuggestionList);
const updateFavLabs = async (lab) => {
  try {
    let updatedFavs = [...fav];
    if (!updatedFavs.includes(lab)) {
      updatedFavs.push(lab);
    }

   const response= await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_schedules: updatedFavs,
    });
 if (response.status === 200) {
      // Update Redux state with the new config
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
         fav_schedules: updatedFavs,
        },
      }));
    }
    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error updating fav labs:", error);
  }
};
const removeFavbutton = async (lab) => {
  try {
    // Create a new array without the lab to remove
    const updatedFavs = fav.filter((l) => l !== lab);

    // Update the server
    const response = await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_schedules: updatedFavs,
    });

    if (response.status === 200) {
      // Update Redux state
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
          fav_schedules: updatedFavs,
        },
      }));
    }

    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error removing fav lab:", error);
  }
};
const handlebuttonclick = async (x) => {
  if (isLoading) return; // Prevent multiple clicks
  isLoading = true;

  try {
    const contentToAdd = x; // Assuming it's a string

    if (!selectedTabs.includes(contentToAdd) &&
        !selectedSuggestionList.some((item) => item.ordername === contentToAdd)) {
      await handleTabClick(contentToAdd);
      selectedTabs.push(contentToAdd);
    }
  } catch (error) {
    console.error("Error in handleStrepFluCovidClick:", error);
  } finally {
    isLoading = false;
  }
};
  const isOn = (content) => selectedTabs.includes(content);
  const setItems = data.filter(
    (item) => item.content === "INHOUSE LABS-MALE" || item.content === "INHOUSE LABS-FEMALE"
  );

  return (
    <div className="bmor">
      {loading ? (
        <div className="bmor-skel" style={{ marginTop: 16 }}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" width={120} height={42} style={{ borderRadius: 999 }} />
          ))}
        </div>
      ) : data.length > 0 ? (
        <>
          {/* Order sets sit under Favourites (no separate heading). */}
          <div className="bmor-section">
            <span className="bmor-section-title">
              <span style={{ width: 14, height: 14, color: "#e0a422", display: "inline-flex" }}>{OrderIcons.star}</span>
              Favourites
            </span>
            <span className="bmor-section-hint">Your saved schedules</span>
          </div>
          {setItems.length > 0 && (
            <>
              <div className="bmor-chips">
                {setItems.map((item) => (
                  <button
                    key={item.content}
                    type="button"
                    className={`bmor-set cat-other${isOn(item.content) ? " on" : ""}`}
                    onClick={() => handleTabClick(item.content)}
                  >
                    {OrderIcons.schedule}
                    {item.content}
                    <span className="bmor-set-tag">Schedule</span>
                  </button>
                ))}
              </div>
            </>
          )}

          <div className="bmor-chips">
            {fav.map((lab) => (
              <button
                key={lab}
                type="button"
                className={`bmor-chip${isOn(lab) ? " on" : ""}`}
                onClick={() => handlebuttonclick(lab)}
              >
                {isOn(lab) ? OrderIcons.check : OrderIcons.plus}
                {lab}
                <span
                  className="bmor-chip-x"
                  role="button"
                  title="Remove from favourites"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent parent click
                    removeFavbutton(lab);
                  }}
                >
                  ×
                </span>
              </button>
            ))}
            <button
              type="button"
              className="bmor-chip ghost"
              title="Add Favourites"
              aria-expanded={!!selectedAddTabs}
              onClick={() => setSelectedAddTabs((prev) => !prev)}
            >
              {selectedAddTabs ? "Done" : <>{OrderIcons.plus}Add favourite</>}
            </button>
          </div>
          {!!selectedAddTabs && (
            <div className="bmor-chips" style={{ marginTop: 10 }}>
              {data
                .filter(
                  (x) =>
                    x.content !== "INHOUSE LABS-MALE" &&
                    x.content !== "INHOUSE LABS-FEMALE" &&
                    !fav.includes(x.content)
                )
                .map((item) => (
                  <button
                    key={item.content}
                    type="button"
                    className="bmor-chip"
                    onClick={() => updateFavLabs(item.content)}
                  >
                    <span style={{ color: "#d0533f", display: "inline-flex" }}>{OrderIcons.heart}</span>
                    {item.content}
                  </button>
                ))}
            </div>
          )}

          <div className="bmor-section">
            <span className="bmor-section-title">
              <span className="bmor-section-dot" style={{ background: "#e07a4f" }} />
              Schedule
            </span>
            <span className="bmor-section-hint">Select to add, select again to remove</span>
          </div>
          <div className="bmor-chips">
            {data
              .filter((x) => x.content !== "INHOUSE LABS-MALE" && x.content !== "INHOUSE LABS-FEMALE")
              .map((item) => {
                const isSelected = selectedTabs.includes(item.content);
                return (
                  <button
                    key={item.content}
                    type="button"
                    className={`bmor-chip${isSelected ? " on" : ""}`}
                    aria-pressed={isSelected}
                    onClick={() => handleTabClick(item.content)}
                  >
                    {isSelected ? OrderIcons.check : OrderIcons.plus}
                    {item.content}
                  </button>
                );
              })}
          </div>
        </>
      ) : (
        <p className="bmor-empty-line" style={{ marginTop: 16 }}>No suggestions found</p>
      )}
    </div>
  );
};

export default ScheduleButtons;
